<template>
  <div class="center">
    <img src="../assets/icon/error.svg" alt="">
    <p>错误: {{ msg }}</p>
  </div>
</template>

<script>
export default {
  data () {
    return {
      msg: '请重新扫码进入！'
    }
  },
  mounted () {
    const q = this.$route.query || {}
    const p = this.$route.params || {}
    this.msg = q.msg || p.errInfo || '请重新扫码进入！'
  }
}
</script>
<style lang="css" scoped>
  .center {
    margin-top: 30%;
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  p {
    font-size: 36px;
    margin-top: 50px;
  }
</style>
